import React from 'react';

const MentorCardSkeleton: React.FC = () => {
  return (
    <div className="group relative w-full overflow-hidden rounded-lg border border-gray-200 bg-white">
      {/* Banner */}
      <div className="relative h-24 animate-pulse bg-gray-200" />

      {/* Profile picture placeholder */}
      <div className="absolute -bottom-4 left-4 top-20 z-50">
        <div className="size-24 animate-pulse overflow-hidden rounded-full border-4 border-gray-300 bg-gray-200" />
      </div>

      {/* Profile Content */}
      <div className="relative z-20 px-4 pb-4 pt-8">
        <div className="space-y-4">
          {/* Name placeholder */}
          <div className="space-y-2">
            <div className="h-6 w-2/3 animate-pulse rounded bg-gray-200" />
            <div className="h-4 w-1/2 animate-pulse rounded bg-gray-200" />
          </div>

          {/* Description placeholder */}
          <div className="space-y-2">
            <div className="h-4 w-full animate-pulse rounded bg-gray-200" />
            <div className="h-4 w-5/6 animate-pulse rounded bg-gray-200" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MentorCardSkeleton;
